module.exports = __webpack_public_path__ + "img/face-smile-hearts.cf0dbc43.svg";